/**
 * IntersectionObserverを用いた要素の表示/非表示制御モジュール
 *
 * - 指定トリガー要素が画面内に入ると、ターゲット要素のクラスを切り替え
 * - addClass/removeClassモードで表示/非表示の動作を柔軟に制御
 * - onceオプションで一度だけ実行も可能
 *
 * @example
 *   new VisibilityToggler({
 *     target: document.getElementById('target'),
 *     trigger: '#trigger',
 *     mode: 'removeClass',
 *     className: 'is-hidden',
 *     rootMargin: '-50px',
 *     once: true
 *   });
 *
 * 注意:
 * - trigger/targetは必須
 * - IntersectionObserver未対応ブラウザでは動作しない
 */
export class VisibilityToggler {
	constructor(options = {}) {
		this.target = options.target;
		this.trigger = document.querySelector(options.trigger);

		this.mode = options.mode || 'removeClass'; // "removeClass" または "addClass"
		this.className = options.className || 'is-hidden';
		this.rootMargin = options.rootMargin || '0px';
		this.once = options.once || false; // ✅ 一度だけ実行するか

		if (!this.target || !this.trigger) return;

		this.initObserver();
	}

	/**
	 * IntersectionObserverを初期化し、トリガー監視開始
	 */
	initObserver() {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				// obsを受け取って解除可能に
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.applyMode(true);

						if (this.once) {
							// 一度だけなら observer を解除
							obs.unobserve(this.trigger);
						}
					} else {
						if (!this.once) {
							this.applyMode(false);
						}
					}
				});
			},
			{
				rootMargin: this.rootMargin,
			}
		);

		observer.observe(this.trigger);
	}

	/**
	 * 指定モードでターゲット要素のクラスを切り替え
	 * @param {boolean} isVisible トリガーが可視かどうか
	 */
	applyMode(isVisible) {
		if (this.mode === 'addClass') {
			isVisible
				? this.target.classList.add(this.className)
				: this.target.classList.remove(this.className);
		} else {
			isVisible
				? this.target.classList.remove(this.className)
				: this.target.classList.add(this.className);
		}
	}
}
